import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { GrupoService } from '../../../../../services/grupo.service';
import { SolicitudService } from '../../../../../services/solicitud.service';
import { DataTableDirective } from 'angular-datatables';

@Component({
	selector: 'app-atendidas',
	templateUrl: './atendidas.component.html',
	styleUrls: ['./atendidas.component.css'],
	providers: [GrupoService, SolicitudService]
})
export class AtendidasComponent implements OnInit {
	public identity;
	public token;
	public status;
	public solicitudes;
	public message_error;
	public message_success;
	public dtOptions: DataTables.Settings = {};
	public dtTrigger: Subject<any> = new Subject();

	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective;

	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _grupoService: GrupoService,
		private _solicitudService: SolicitudService,
	) {
		this.identity = this._grupoService.getIdentity();
		this.token = this._grupoService.getToken();
	}

	ngOnInit() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 10
		}
		this.getSolicitudes();
	}

	getSolicitudes() {
		this._solicitudService.getSolicitudesAtendidas(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.solicitudes = response.solicitudes;
					this.dtTrigger.next();
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				}
			}
		);
	}

	resend(solicitud_id, estatus) {

		if (estatus == '-1') {
			let observacion = $("#observacion" + solicitud_id).val();
			let email = $("#email" + solicitud_id).val();
			let info = { observacion, email }
			$(".loading").show();

			this._solicitudService.delete(this.token, info, solicitud_id).subscribe(
				response => {
					$(".loading").hide();
					if (response.status == "success") {
						this.status = 'success'
						$(".reenviar").show();
						this.message_success = 'Se ha reenviado el correo electrónico al grupo empresarial'
						setTimeout(function () {
							$(".reenviar")
								.fadeTo(500, 1)
								.slideUp(500, function () {
									$(".reenviar").hide();
								});
						}, 3000);

					}
				},
				error => {
					if (error["status"] == 401) {
						this._router.navigate(["logout/1"]);
					} else if (error.error.message) {
						$(".loading").hide();
						$(".reenviar").show();
						this.status = 'error';
						this.message_error = error.error.message;

						setTimeout(function () {
							$(".reenviar")
								.fadeTo(500, 1)
								.slideUp(500, function () {
									$(".reenviar").hide();
								});
						}, 3000);
					} else {
						alert(' Existen problemas en el servidor, intente más tarde')
					}
				}
			);
		} else if (estatus == '1') {
			let email = $("#email" + solicitud_id).val();
			let info = { solicitud_id, email }

			$(".loading").show();

			this._solicitudService.resendEmailSolicitud(this.token, info).subscribe(
				response => {
					$(".loading").hide();
					if (response.status == "success") {
						this.status = 'success'
						$(".reenviar").show();
						this.message_success = response.message
						setTimeout(function () {
							$(".reenviar")
								.fadeTo(500, 1)
								.slideUp(500, function () {
									$(".reenviar").hide();
								});
						}, 3000);

					}
				},
				error => {
					if (error["status"] == 401) {
						this._router.navigate(["logout/1"]);
					} else if (error.error.message) {
						$(".loading").hide();
						$(".reenviar").show();
						this.status = 'error';
						this.message_error = error.error.message;

						setTimeout(function () {
							$(".reenviar")
								.fadeTo(500, 1)
								.slideUp(500, function () {
									$(".reenviar").hide();
								});
						}, 3000);
					} else {
						alert(' Existen problemas en el servidor, intente más tarde')
					}
				}
			);
		}


	}

}
